module.exports = __webpack_public_path__ + "assets/okey_icn@1x.c1cbc0f1.svg";